export const ExerciseSetButton: React.FC<{
  onClick?: (e: React.MouseEvent) => void;
  isEditable?: boolean;
  isAddButton?: boolean;
  children?: React.ReactNode;
}> = ({ onClick, isEditable = false, isAddButton = false, children }) => {
  if (isAddButton && onClick) {
    return (
      <button
        onClick={onClick}
        className={`text-xs px-3 py-1 mr-auto rounded  transition-colors bg-gray-200 ${isEditable ? "hover:bg-secondary hover:text-white" : "cursor-not-allowed"}`}
        aria-label="Add set"
        disabled={!isEditable}
      >
        <svg
          className="w-3 h-3"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 4v16m8-8H4"
          />
        </svg>
      </button>
    );
  }

  return onClick ? (
    <button
      onClick={onClick}
      className={`text-xs bg-white px-2 py-1 rounded border transition-colors ${isEditable ? "hover:bg-secondary hover:text-white" : "cursor-not-allowed"}`}
      disabled={!isEditable}
    >
      {children}
    </button>
  ) : (
    <div className="text-xs bg-white px-2 py-1 rounded border transition-colors">
      {children}
    </div>
  );
};
